import t from "./index922.js";
import o from "./index923.js";
import r from "./index838.js";
function s(e) {
  return t(e, r, o);
}
export {
  s as default
};
